import { ErrorCode } from '../atoms/exchange-availability.js';
export const PREFILL_OPTIONS = {
    min: 'min',
    half: 'half',
    max: 'max',
    all: 'all',
};
const initialState = {
    form: {
        fromAmount: null,
        fromAsset: null,
        prefillOptionId: null,
        slippage: null,
        toAmount: null,
        toAsset: null,
    },
    quotes: {},
    status: null,
    availability: {
        isAvailable: false,
        reason: {
            code: ErrorCode.TemporarilyUnavailable,
        },
    },
    exchangeableAssets: {
        fromAssetIds: [],
        toAssetIds: [],
    },
};
export default initialState;
